import AssessmentParticipantLayout from "./AssessmentParticipantLayout";

function AssessmentParticipantApp() {
  return <AssessmentParticipantLayout />;
}

export default AssessmentParticipantApp;
